module.exports = __webpack_public_path__ + "assets/img/tab1_01.9bb7e57f.jpg";